<template>
  <form @submit.prevent="addNewCar">
    <div class="card">

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h3 class="">Car Details <br><br></h3>
            <div class="form-group">
              <label>Vehicle Name</label>
              <input type="text" v-model="carName" required class="form-control" placeholder="eg. Tesla">
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <h2 class="header-title">
              Display Fields <br><br>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-for="(field, index) in additionalFields">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" required v-model="field.fieldName" class="form-control" placeholder="Enter Field Name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" required v-model="field.fieldValue" class="form-control" placeholder="Enter Field Value">
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <button class="btn btn-sm btn-outline-danger" @click="additionalFields.splice(index, 1)">Remove
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-outline-dark" @click="additionalFields.push({fieldName: ''})"><i
                class="fa fa-plus"></i> Add New Additional Field
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="header-title">Vehicle Images</h4>
        <p class="sub-header">Upload product image</p>
        <div class="row">
          <div class="col-md-4">
            <vue-dropzone
                id="mainImage"
                ref="mainImage"
                :use-custom-slot="true"
                :options="mainImageDropzoneOptions"
                @vdropzone-max-files-exceeded="mainImageMaxFileExceeded"
            >
              <div class="dz-message needsclick">
                <i class="h1 text-muted ri-upload-cloud-2-line"></i>
                <h3>Upload main image</h3>
              </div>
            </vue-dropzone>
          </div>
          <div class="col-md-8">
            <vue-dropzone
                id="supportingImages"
                ref="supportingImage"
                :use-custom-slot="true"
                :options="supportingImageDropzoneOptions"
                @vdropzone-max-files-exceeded="supportingImageMaxFileExceeded"
            >
              <div class="dz-message needsclick">
                <i class="h1 text-muted ri-upload-cloud-2-line"></i>
                <h3>Drop supporting images here or click to upload.</h3>

              </div>
            </vue-dropzone>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">

        <h4 class="header-title mb-4">Car Details Fields</h4>

        <div class="row">

          <div class="col-md-12">
            <div class="form-group">
              <h5> Unique identifier field (eg. Car plate, telephone number, etc) ? </h5>
              <div class="mb-2">
                <router-link to="/car/list">Please note: The car identifier values should be specified in the car's
                  detail section
                </router-link>
              </div>

              <b-form-checkbox
                  v-model="uniqueIdFieldName.hasUniqueIdField"
                  value="Yes"
                  switch
                  unchecked-value="No"
              >
                {{ uniqueIdFieldName.hasUniqueIdField }} <span class="text-danger ml-4">Recommended value = Yes</span>
              </b-form-checkbox>
            </div>

          </div>


          <div class="col-md-6" v-if="uniqueIdFieldName.hasUniqueIdField === 'Yes'">
            <div class="form-group">
              <label>The unique identifier field name</label>
              <input type="text" v-model="uniqueIdFieldName.uniqueIdFieldName" required class="form-control" placeholder="Enter field name here">
            </div>

          </div>

        </div>

        <h4 class="header-title mt-4">Special Fields</h4>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <h6> Does car has a <b>total</b> field ?</h6>
            <b-form-checkbox
                v-model="totalField.hasTotalField"
                value="Yes"
                switch
                unchecked-value="No"
            >
              {{ totalField.hasTotalField }}
            </b-form-checkbox>
          </div>

          <div class="col-md-6">
            <h6> Does excel file has a <b>Date Time</b> field ?</h6>
            <b-form-checkbox
                v-model="dateTimeField.hasDateTimeField"
                value="Yes"
                switch
                unchecked-value="No"
            >
              {{ dateTimeField.hasDateTimeField }}
            </b-form-checkbox>
          </div>

        </div>

        <div class="row mt-3" v-if="totalField.hasTotalField === 'Yes'">
          <div class="col-md-6">
            <div class="form-group">
              <label for="car-name"> Total field name <span class="text-danger">*</span> <small class="text-bold">(separate
                translations with comma (,)</small></label>
              <input type="text" class="form-control"
                     placeholder="Enter total field name here"
                     required
                     id="car-name"
                     v-model="totalField.totalField"
              >
            </div>
          </div>
        </div>

        <div class="row mt-3" v-if="dateTimeField.hasDateTimeField === 'Yes'">
          <div class="col-md-6">
            <div class="form-group">
              <label for="date-time"> Date time field name <span class="text-danger">*</span> <small class="text-bold">(separate
                translations with comma (,)</small></label>
              <input type="text" class="form-control"
                     placeholder="Enter date time field name here"
                     required
                     id="date-time"
                     v-model="dateTimeField.dateTimeField"
              >
            </div>
          </div>
        </div>


        <h4 class="header-title mt-4">PickUp Location</h4>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="location"> Location <span class="text-danger">*</span> <small class="text-bold">where the
                car will be picked after booking</small></label>
              <input type="text" class="form-control"
                     placeholder="eg. North Holland, Netherlands"
                     required
                     id="location"
                     v-model="location">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="location"> Location Url<span class="text-danger">*</span> <small class="text-bold">google maps
                link</small></label>
              <input type="text" class="form-control"
                     placeholder="eg. https://maps.app.goo.gl/eVDSPc9wSVMWKf24A"
                     required
                     id="url"
                     v-model="location_url"
              >
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card">

      <div class="card-body">

        <h2 class="header-title mb-3">
          Cost Of Car
        </h2>
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label for="duration">Duration</label>
              <select id="duration" v-model="costDuration" class="form-control" required>
                <option value="day">Daily</option>
                <option value="week">Weekly</option>
                <option value="month">Monthly</option>
                <option value="year">Yearly</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="cost" class="text-capitalize">Cost of Car per {{ costDuration }}</label>
              <div class="input-group input-group-merge">
                <input type="text" id="cost" :value="totalCarCost | toCurrencyFormat" class="form-control" disabled>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">

      <div class="card-body">

        <div class="row">
          <div class="col-md-6">
            <h2 class="header-title mb-4">
              Configure Calculated Fields
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" :class="{'mt-5' : index !== 0 && index !== 1 }"
               v-for="(field, index) in calculatedFields">
            <div class="form-group">
              <label for="calculated">Enter Excel Field <small class="text-bold">(separate translations with comma
                (,)</small> <span class="text-danger">*</span></label>
              <div class="input-group input-group-merge">
                <input type="text" class="form-control" id="calculated"
                       placeholder="Enter label as it will appear on mobile app"
                       required
                       v-model="field.fieldName"
                >
                <div class="input-group-append">
                  <div class="input-group-text bg-danger" @click="removeCalculatedField(index)" style="cursor: pointer">
                    <span class="fa fa-trash text-white"></span>
                  </div>
                </div>
              </div>

              <b-form-group>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-7">
                        <input type="text" class="form-control mb-2" id="calculated"
                               :placeholder="`${field.fieldName}'s value`"
                               required @input="calculateTax(index)"
                               v-model="field.fieldValue"
                        >
                      </div>
                    </div>

                  </div>
                  <div class="col-md-6">
                    <b-form-radio
                        v-model="field.fieldType" :name="'calc-type-' + index"
                        value="income">Verkoop
                    </b-form-radio>
                  </div>
                  <div class="col-md-6">
                    <b-form-radio
                        v-model="field.fieldType"
                        :name="'calc-type-' + index"
                        value="cost">
                      Inkoop
                    </b-form-radio>
                  </div>

                </div>
              </b-form-group>

              <!--           Gross / Net     -->
              <b-form-group>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <b-form-radio
                        v-model="field.grossOrNet" :name="'gross-net-' + index"
                        value="gross">Gross
                    </b-form-radio>
                  </div>
                  <div class="col-md-6">
                    <b-form-radio
                        v-model="field.grossOrNet"
                        :name="'gross-net-' + index"
                        value="net">Net
                    </b-form-radio>
                  </div>

                </div>
              </b-form-group>


              <div class="row mt-2">
                <div class="col-md-6">
                  <b-form-checkbox
                      v-model="field.weeklyPayment"
                      switch
                  >
                    Show field in weekly payments
                  </b-form-checkbox>
                </div>
                <div class="col-md-6">
                  <b-form-checkbox v-model="field.fAdministration"
                                   switch>
                    Show field in F. administration
                  </b-form-checkbox>
                </div>
              </div>

            </div>
          </div>

          <div class="col-md-12 text-right mt-4">
            <button class="btn btn-outline-dark" type="button" @click="addCalculatedField"><i class="fa fa-plus"></i>
              Add New Calc Field
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h2 class="header-title mb-4">
              Configure Tax Fields
            </h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6" :class="{'mt-5' : index !== 0 && index !== 1 }" v-for="(field, index) in taxFields">
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label for="calc-field">Select Reference Field <span class="text-danger">*</span></label>
                  <select name="" id="calc-field" class="form-control" v-model="field.refFieldName" required @change="calculateTax(index)">
                    <option value=""> -- select field --</option>
                    <option :value="f.fieldName" v-for="f in calculatedFields"> {{ f.fieldName }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="tax-type">Select Tax Type <span class="text-danger">*</span></label>
                  <select name="taxType" id="tax-type" class="form-control" v-model="field.taxType" required>
                    <option value=""> -- select field --</option>
                    <option value="upper"> Upper tax</option>
                    <option value="lower"> Lower tax</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label for="tax-formula">Tax Formula (if applicable) <span class="text-danger">*</span></label>
                  <input type="text" id="tax-formula" class="form-control" v-model="field.formula"
                         placeholder="eg.  ref / 32 * 8" @input="calculateTax(index)">
                </div>
                <div class="col-md-6">
                  <label for="tax-value">Actual Value</label>
                  <input type="text" id="tax-value" class="form-control" :value="field.value" disabled>
                </div>
              </div>
            </div>

            <b-form-group>
              <div class="row mt-2">
                <div class="col-md-6">
                  <b-form-radio v-model="field.refFieldType" :name="'tax-type-' + index" value="income">Verkoop
                  </b-form-radio>
                </div>
                <div class="col-md-6">
                  <b-form-radio v-model="field.refFieldType" :name="'tax-type-' + index" value="cost">Inkoop
                  </b-form-radio>
                </div>
              </div>
            </b-form-group>

            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <b-form-checkbox v-model="field.weeklyPayment" switch>
                    Show field in weekly payments
                  </b-form-checkbox>
                </div>
                <div class="col-md-6">
                  <b-form-checkbox v-model="field.fAdministration" switch>
                    Show field in F. administration
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <button type="button" class="btn btn-outline-danger" @click="removeTaxField(index)"><i
                class="fa fa-trash text-danger"></i> <span class="ml-2">Delete tax field</span></button>

          </div>

          <div class="col-md-12 text-right mt-4">
            <button class="btn btn-outline-dark" type="button" @click="addTaxField"><i class="fa fa-plus"></i> Add New
              Tax Field
            </button>
          </div>

        </div>

      </div>
    </div>

    <!--    extra fields-->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h2 class="header-title mb-4">
              Configure Extra Fields
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" :class="{'mt-5' : index !== 0 && index !== 1 }"
               v-for="(field, index) in extraFields">
            <div class="form-group">
              <div class="row">
                <div class="col-md-8">
                  <label for="calculated">Enter Excel Field <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="calculated"
                         placeholder="Enter label as it will appear on mobile app"
                         required
                         v-model="field.fieldName"
                  />
                </div>
                <div class="col-md-4">
                  <label for="extra-field">&nbsp;</label>
                  <div class="input-group input-group-merge">
                    <input type="text" class="form-control" id="extra-field"
                           :placeholder="`${field.fieldName}'s value`"
                           required @input="calculateExtraTax(index)"
                           v-model="field.fieldValue"/>
                    <div class="input-group-append">
                      <div class="input-group-text bg-danger" @click="removeExtraField(index)" style="cursor: pointer">
                        <span class="fa fa-trash text-white"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>


          </div>

          <div class="col-md-12 text-right mt-4">
            <button class="btn btn-outline-dark" type="button" @click="addExtraField"><i class="fa fa-plus"></i>
              Add Extra Field
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--    extra tax fields-->
    <div class="card">

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h2 class="header-title mb-4">
              Configure Extra Tax Fields
            </h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6" :class="{'mt-5' : index !== 0 && index !== 1 }"
               v-for="(field, index) in extraTaxFields">
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label for="calc-field">Select Reference Field <span class="text-danger">*</span></label>
                  <select name="" id="calc-field" class="form-control" @change="calculateExtraTax(index)"
                          v-model="field.refFieldName" required>
                    <option value=""> -- select field --</option>
                    <option :value="f.fieldName" v-for="f in extraFields"> {{ f.fieldName }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="tax-type">Select Tax Type <span class="text-danger">*</span></label>
                  <select name="taxType" id="tax-type" class="form-control" v-model="field.taxType" required>
                    <option value=""> -- select field --</option>
                    <option value="upper"> Upper tax</option>
                    <option value="lower"> Lower tax</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label for="tax-formula">Tax Formula (if applicable) <span class="text-danger">*</span></label>
                  <input type="text" id="tax-formula" class="form-control" v-model="field.formula"
                         placeholder="eg.  ref / 32 * 8" @input="calculateExtraTax(index)">
                </div>
                <div class="col-md-6">
                  <label for="tax-value">Actual Value</label>
                  <input type="text" id="tax-value" class="form-control" :value="field.value" disabled>
                </div>
              </div>
            </div>

            <button type="button" class="btn btn-outline-danger" @click="removeExtraTaxField(index)"><i
                class="fa fa-trash text-danger"></i> <span class="ml-2">Delete tax field</span></button>
          </div>

          <div class="col-md-12 text-right mt-4">
            <button class="btn btn-outline-dark" type="button" @click="addExtraTaxField"><i class="fa fa-plus"></i> Add
              Extra Tax Field
            </button>
          </div>

        </div>

      </div>
    </div>

    <div class="card">
      <div class="card-body text-center">
        <button type="submit" class="btn btn-dark"> Save Fields</button>
      </div>
    </div>
  </form>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import vue2Dropzone from "vue2-dropzone";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import {financialAdministrationService} from "@/apis/financial.administration.service";

/**
 * Add-car component
 */
export default {
  name: "AddNewCar",
  data() {
    return {
      mainImage: '',
      supportingFiles: '',
      carName: '',
      mainImageDropzoneOptions: {
        url: '#',
        addRemoveLinks: true,
        maxFilesize: 0.5,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        autoProcessQueue: false,
        maxFiles: 1,
      },

      supportingImageDropzoneOptions: {
        url: '#',
        maxFilesize: 0.5,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 3,
      },
      uniqueIdFieldName: {
        hasUniqueIdField : 'Yes',
        uniqueIdFieldName: ''
      },
      totalField: {
        hasTotalField: 'Yes',
        totalField: ''
      },
      dateTimeField: {
        hasDateTimeField: 'No',
        dateTimeField: ''
      },
      costDuration: 'week',
      calculatedFields: [],
      taxFields: [],
      extraFields: [],
      extraTaxFields: [],
      additionalFields: [],
      car_config: null,
      location: '',
      location_url: '',
    };
  },
  components: {
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    vueDropzone: vue2Dropzone,
  },
  watch: {
    calculatedFields: {
      handler(newFields) {
        this.taxFields.forEach((field, index) => {
          const reference = newFields.find(
              (f) => f.fieldName === field.refFieldName
          );

          if (!field.formula || !reference) {
            field.value = 0;
            return;
          }

          if (!reference.fieldValue) {
            field.value = 0;
            return;
          }

          try {
            const formula = field.formula.replace(/ref/g, reference.fieldValue);
            field.value = Function(`"use strict"; return (${formula})`)();
          } catch (error) {
            console.error("Invalid formula:", error);
            field.value = 0;
          }
        });
      },
      deep: true,
    },
  },

  computed: {
    totalCarCost() {
      const calculatedValuesSum = this.calculatedFields.reduce((sum, field) => {
        if (!field.fAdministration && !field.weeklyPayment) return sum; // Skip if not for administration or weekly payment
        return sum + (parseFloat(field.fieldValue) || 0);
      }, 0);

      const taxValuesSum = this.taxFields.reduce(
          (sum, field) => {
            if (!field.fAdministration && !field.weeklyPayment) return sum; // Skip if not for administration or weekly payment
            return sum + (parseFloat(field.value) || 0)
          }, 0);

      const extraValuesSum = this.extraFields.reduce(
          (sum, field) => sum + (parseFloat(field.fieldValue) || 0), 0);

      const extraTaxValuesSum = this.extraTaxFields.reduce(
          (sum, field) => sum + (parseFloat(field.value) || 0),
          0
      );
      return calculatedValuesSum + taxValuesSum + extraValuesSum + extraTaxValuesSum;
    },
  },
  methods: {
    calculateFieldValue(index, fields, referenceFields) {
      const field = fields[index];
      if (!field) return;

      const reference = referenceFields.find((f) => f.fieldName === field.refFieldName);

      if (!field.formula || !reference) {
        field.value = 0;
        return;
      }

      if (!reference.fieldValue) {
        field.value = 0;
        return;
      }

      try {
        const formula = field.formula.replace(/ref/g, reference.fieldValue);
        field.value = parseFloat(eval(formula)).toFixed(2);
      } catch (error) {
        field.value = 0;
      }
    },

    calculateTax(index) {
      this.calculateFieldValue(index, this.taxFields, this.calculatedFields);
    },

    calculateExtraTax(index) {
      this.calculateFieldValue(index, this.extraTaxFields, this.extraFields);
    },

    addNewCar() {
      this.mainImage = this.$refs.mainImage.getAcceptedFiles();
      this.supportingFiles = this.$refs.supportingImage.getAcceptedFiles();

      if (this.mainImage.length === 0) {
        this.$store.dispatch('error', {
          message: "Please upload the car's image",
          showSwal: true
        })
        return;
      }

      let mainImage = this.mainImage[0];

      const formData = new FormData();
      formData.append("main_image", mainImage);

      this.supportingFiles.forEach(el => {
        formData.append("supporting_images[]", el);
      })

      formData.append("name", this.carName);
      formData.append("cost_duration", this.costDuration);
      formData.append("cost_per_period", this.totalCarCost);
      formData.append("location", this.location);
      formData.append("location_url", this.location_url);

      //extra configs
      formData.append("calculated_fields", this.calculatedFields ? JSON.stringify(this.calculatedFields) : '');
      formData.append("additional_fields", this.additionalFields ? JSON.stringify(this.additionalFields) : '');
      formData.append("tax_fields", this.taxFields ? JSON.stringify(this.taxFields) : '');
      formData.append("extra_fields", this.extraFields ? JSON.stringify(this.extraFields) : '');
      formData.append("extra_tax_fields", this.extraTaxFields ? JSON.stringify(this.extraTaxFields) : '');
      formData.append("date_time_field", this.dateTimeField ? JSON.stringify(this.dateTimeField) : '');
      formData.append("total_field", this.totalField ? JSON.stringify(this.totalField) : '');
      formData.append("unique_identifier", this.uniqueIdFieldName ? JSON.stringify(this.uniqueIdFieldName) : '');

      this.$store.dispatch('addNewCar', formData).then(() => {
        // this.$router.push('/rentals/show-room');
      })
    },

    mainImageMaxFileExceeded(file) {
      this.$refs.mainImage.removeFile(file);
    },

    supportingImageMaxFileExceeded(file) {
      this.$refs.supportingImage.removeFile(file);
    },

    removeCalculatedField(index) {
      this.calculatedFields.splice(index, 1);
    },

    removeTaxField(index) {
      this.taxFields.splice(index, 1);
    },

    removeExtraField(index) {
      this.extraFields.splice(index, 1);
    },

    removeExtraTaxField(index) {
      this.extraTaxFields.splice(index, 1);
    },

    addCalculatedField: function () {
      this.calculatedFields.push({
        fieldName: '',
        fieldType: 'income', // income / cost
        grossOrNet: '',
        weeklyPayment: true,
        fAdministration: true,
      });
    },

    addTaxField: function () {
      this.taxFields.push({
        refFieldName: '',
        refFieldType: '', // income / cost
        taxType: '',
        formula: '',
        weeklyPayment: false,
        fAdministration: true,
      });
    },

    addExtraField() {
      this.extraFields.push({
        fieldName: '',
        fieldType: 'income', // income / cost
        grossOrNet: '',
        weeklyPayment: true,
        fAdministration: true,
      });
    },

    addExtraTaxField() {
      this.extraTaxFields.push({
        refFieldName: '',
        refFieldType: '', // income / cost
        taxType: '',
        formula: '',
        weeklyPayment: false,
        fAdministration: true,
      });
    },

    fetchInternalDataConfigFields() {
      this.$store.dispatch('showLoader');
      financialAdministrationService.getInternalDataConfigFields('car-config').then(response => {
        this.$store.dispatch('hideLoader');
        const {status, extra} = response;
        if (!status) {
          this.$store.dispatch('error', {message: response.message});
          return;
        }
        this.car_config = extra;
        if (!this.car_config) {
          this.calculatedFields = [];
          this.taxFields = [];
          this.additionalFields = [];
          this.extraFields = [];
          this.extraTaxFields = [];
          return;
        }

        this.location = this.car_config['location'] || '';
        this.location_url = this.car_config['location_url'] || '';

        this.calculatedFields = JSON.parse(this.car_config.calculated_fields)
        this.taxFields = JSON.parse(this.car_config['tax_fields'])
        // this.extraFields = JSON.parse(this.car_config['extra_fields'])
        // this.extraTaxFields = JSON.parse(this.car_config['extra_tax_fields'])
        this.additionalFields = JSON.parse(this.car_config['additional_fields']);

        if (this.car_config['total_field']) {
          this.totalField = JSON.parse(this.car_config['total_field']);
        }

        if (this.car_config['date_time_field']) {
          this.dateTimeField = JSON.parse(this.car_config['date_time_field']);
        }

        if (this.car_config['unique_identifier']) {
          this.uniqueIdFieldName = JSON.parse(this.car_config['unique_identifier']);
        }
      })
    },
  },
  created() {
    this.fetchInternalDataConfigFields()
  },
  middleware: "router-auth",
};
</script>

<style>
#myDropzone .dz-preview .dz-progress {
  opacity: .50;
}
</style>